export const innerPageType = {
  STRING: 'string',
  NUMBER: 'number'
} as const
